<template>
    <div>
        <div class="orderdetails_head_content">
            <table>
                <colgroup>
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                    <col width="11.5873%">
                    <col width="21.746%">
                </colgroup>
                <tbody>
                    <tr>
                        <th><span>订单号：</span></th>
                        <td><span>{{orderinfo.orderdno}}</span><small style="color: red;" v-if="orderinfo.batchcost >= 0"> (特批价)</small></td>
                        <th><span>订单状态：</span></th>
                        <td><span :style="{color: orderinfo.status != 4 && orderinfo.status != 5 && orderinfo.status != 6 ? '#FF8000' : ''}">{{orderinfo.statusname}}</span><small v-if="orderinfo.ordertype == 1">{{orderinfo.ordertypename}}</small></td>
                        <th><span>订单金额：</span></th>
                        <td><span>￥{{orderinfo.allcost}}</span><small style="color: #999;" v-if="orderinfo.ordertype == 1"> {{orderinfo.ordertypename}}</small></td>
                    </tr>
                    <tr>
                        <th><span>订单时间：</span></th>
                        <td><span>{{orderinfo.addtime}}</span></td>
                        <th><span>付款状态：</span></th>
                        <td><span :style="{color: orderinfo.fundstatus != 4 && orderinfo.fundstatus != 5 ? '#FF8000' : ''}">{{orderinfo.fundstatusname}}</span></td>
                        <th><span>待付金额：</span></th>
                        <td><span>￥{{orderinfo.waitcost}}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="tabs_content">
            <ul>
                <li @click="orderjump(1)">订货详情</li>
                <li @click="orderjump(2)">出库/发货/物流</li>
                <li class="active">付款记录</li>
            </ul>
        </div>
        <div class="orderdetails_box">
            <div class="shoppingcart_head_check_content">
                <div class="shoppingcart_head_check_left"></div>
                <div class="shoppingcart_head_check_right">
                    <Button type="warning" v-if="orderinfo.waitcost > 0 && orderinfo.fundstatus < 5" @click="payBtn">付款</Button>
                </div>
            </div>
            <div class="orderdetails_table_content pad0">
                <Table
                    border
                    ref="selection"
                    :columns="thead"
                    :data="goodslist"></Table>
            </div>
        </div>
        <PayRecord :payrecordShow="payrecordShow" :payrecordtype="payrecordtype" :payrecordinfo="goodslist[payrecordinfo]" @payrecordCancel="payrecordCancel"></PayRecord>
    </div>
</template>

<script>
import api from '@/request/api.js'
import PayRecord from '@/components/component/popup/payrecord.vue'
export default {
    components: {PayRecord},
    data() {
        return {
            orderinfo: {}, // 订单信息
            payrecordinfo: 0, 
            payrecordShow: false, // 详情弹窗
            payrecordtype: 0, // 弹窗类型 0 支付记录 1 预存款收支明细
            thead: [ // 表格头部
                {
                    type: 'index',
                    width: 50,
                    align: 'center',
                },
                {
                    align: 'center',
                    title: '支付时间',
                    key: 'paytime'
                },
                {
                    align: 'center',
                    title: '支付方式',
                    key: 'paytype'
                },
                {
                    align: 'center',
                    title: '收款账号',
                    key: 'dw',
                    render: (h, params) => {
                        return h('div',
                                    {
                                        class: 'payrecord_payee_content'
                                    },
                                    [
                                        h('span', params.row.accountbank),
                                        h('span', params.row.accountname),
                                        h('span', params.row.accountnum),
                                    ]
                                )
                    }
                },
                {
                    align: 'center',
                    title: '金额',
                    key: 'cost'
                },
                {
                    align: 'center',
                    title: '收款状态',
                    key: 'statusname'
                },
                {
                    width: 166,
                    align: 'center',
                    title: '操作',
                    key: 'instro',
                    render: (h, params) => {
                        return h('span',
                                    {
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        on: {
                                            click: () => {
                                                this.payrecordOk(params.index)
                                            }
                                        }
                                    },
                                    '详情'
                                )
                    }
                }
            ],
            goodslist: [], // 表格列表
        }
    },
    methods: {
        getInfo () { // 获取付款记录
            this.http.post(api.payrecord, {id: this.$route.params.id})
            .then(response => {
                if (response.status === 200) {
                    console.log(response.data.msg)
                    this.orderinfo = response.data.msg.orderinfo
                    this.goodslist = response.data.msg.orderfundlist
                }
            })
            .catch(error => {
                console.log(error);
            })
        },
        orderjump (sign) { // 跳转链接
            let links
            if (sign == 1) {
                links = '订货详情'
            } else if (sign == 2) {
                links = '出库/发货/物流'
            } else if (sign == 3) {
                links = '付款记录'
            }
            this.$router.push({
                name: links,
                id: this.$route.params.id
            })
        },
        payrecordOk (index) { // 详情弹窗打开
            this.payrecordinfo = index
            this.payrecordShow = true
        },
        payrecordCancel () { // 详情弹窗关闭
            this.payrecordShow = false
        },
        payBtn () { // 支付按钮
            this.$router.push({
                name: '支付',
                params: {
                    type: 0,
                    id: this.$route.params.id
                }
            })
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/views/order/payrecord.vue